import React from 'react';
import { differentiators } from '../data/content';
export function WhyDifferent() {
  return <section className="grid-texture border-b border-steelLine bg-charcoal px-4 py-8 sm:py-10" data-id="element-165" data-mp="84kka4lwolj8">
      <div className="mx-auto max-w-4xl" data-id="element-166" data-mp="3qik0cuekmr1z">
        <h2 className="text-center text-lg text-white sm:text-2xl" data-id="element-167" data-mp="3qjldr5j27pmv">
          This Isn&apos;t Just Another Collection of <span className="text-gold" data-id="element-168" data-mp="3vf0o3nhuz3ej">Random Files.</span>
        </h2>
        <ul className="mt-4 grid gap-2.5 sm:grid-cols-2" data-id="element-169" data-mp="n2mo8fwun910">
          {differentiators.map(item => <li key={item.title} className="flex gap-3 rounded-md border border-steelLine bg-steel p-3.5" data-id="element-170" data-mp="r1lsdyarb1re">
              <span aria-hidden="true" className="text-xl leading-none" data-id="element-171" data-mp="d2m08go1c4qh">
                {item.emoji}
              </span>
              <div data-id="element-172" data-mp="i4bb9wb9ciek">
                <h3 className="text-sm text-white sm:text-base" data-id="element-173" data-mp="2xtmi2rad0u98">{item.title}</h3>
                <p className="mt-1 text-sm font-medium leading-snug text-lightGray" data-id="element-174" data-mp="2xvpj06d1w7sq">{item.body}</p>
              </div>
            </li>)}
        </ul>
        <p className="mt-3.5 text-center font-display text-sm font-extrabold uppercase tracking-wide text-gold sm:text-base" data-id="element-175" data-mp="3kr9eo0lc35mo">
          Less searching. Less designing. More building.
        </p>
      </div>
    </section>;
}